var map = {
	"./border-bg-sm.png": 1390,
	"./border-bg.png": 1391,
	"./btn-active.png": 1392,
	"./cny-flower-1.webp": 1393,
	"./cny-flower-2.webp": 1394,
	"./cny-mobile-bg.webp": 1395,
	"./content-deco-1.webp": 1396,
	"./content-deco-2.webp": 1397,
	"./content-deco-3.webp": 1398,
	"./content-deco-4.webp": 1399,
	"./content-deco-5.webp": 1400,
	"./deposit-icon.webp": 1401,
	"./home-icon-active.webp": 1402,
	"./home-icon.webp": 1403,
	"./live-icon-active.webp": 1404,
	"./live-icon.webp": 1405,
	"./master-bg.png": 1406,
	"./me-icon-active.webp": 1407,
	"./me-icon.webp": 1408,
	"./platform.webp": 1409,
	"./product-overview-bg.webp": 1410,
	"./promos-icon-active.webp": 1411,
	"./promos-icon.webp": 1412,
	"./sponsor-icon-active.webp": 1413,
	"./sponsor-icon.webp": 1414,
	"./title-deco-bg.webp": 1415,
	"./title-deco-left.webp": 1416,
	"./title-deco-right.webp": 1417,
	"./vip-icon-active.webp": 1418,
	"./vip-icon.webp": 1419,
	"./withdraw-icon.webp": 1420,
	"./wwr-bg.webp": 1421,
	"./wwr-img.webp": 1422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;